import * as React from 'react';
import { ClubProgrammeActionBar } from './ClubProgrammeActionBar';
import { ClubProgrammePager } from './ClubProgrammePager';
import { badgeClass } from '../helpers/clubProgrammeClubsContent';
import { clubProgrammeMenuStyle } from 'Src/helpers/clubProgramme/clubProgrammeUi';

type Props = {
  canEdit: boolean;
  isAddWorking: boolean;

  addAllSelected: boolean;
  addSelectedCount: number;
  addHasAnySelection: boolean;
  addIsPartialAll: boolean;

  addItems: any[];
  addTotal: number;

  addPage: number;
  addPages: number;
  addFrom: number;
  addTo: number;
  loadAddPage: (page: number) => void;

  addSelectMenuOpen: boolean;
  setAddSelectMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
  addSelectMenuWrapRef: React.RefObject<HTMLDivElement | null>;

  addSelectThisPage: (rows: any[]) => void;
  addSelectAllMatching: () => void;
  addClearSelection: () => void;

  onAddSelected: () => void;
};

export const ClubProgrammeAddClubsActionBar: React.FC<Props> = ({
  canEdit,
  isAddWorking,
  addAllSelected,
  addSelectedCount,
  addHasAnySelection,
  addIsPartialAll,
  addItems,
  addTotal,
  addPage,
  addPages,
  addFrom,
  addTo,
  loadAddPage,
  addSelectMenuOpen,
  setAddSelectMenuOpen,
  addSelectMenuWrapRef,
  addSelectThisPage,
  addSelectAllMatching,
  addClearSelection,
  onAddSelected
}) => {
  return (
    <ClubProgrammeActionBar
      left={
        <>
          <div className="cpAddClubsSelectWrap" ref={addSelectMenuWrapRef as any}>
            <button
              type="button"
              className="cpDsIconTextBtn cpAddClubsSelectionBtn"
              onClick={e => {
                e.stopPropagation();
                setAddSelectMenuOpen(value => !value);
              }}
              disabled={isAddWorking}
            >
              <input
                type="checkbox"
                checked={addAllSelected || addSelectedCount > 0}
                ref={el => {
                  if (!el) return;
                  el.indeterminate = addIsPartialAll;
                }}
                readOnly
                aria-label="Current add-clubs selection"
              />

              <span className={badgeClass(addSelectedCount > 0 ? 'info' : 'warn')}>{addSelectedCount}</span>
              <span>Selection</span>

              {addAllSelected ? <span className={badgeClass('info')}>All matching</span> : null}
              <span className="cpAddClubsChevron">▾</span>
            </button>

            {addSelectMenuOpen ? (
              <div
                className="cpMenu cpAddClubsSelectMenu"
                style={clubProgrammeMenuStyle}
                onClick={e => e.stopPropagation()}
              >
                <button
                  type="button"
                  className="cpAddClubsMenuItem"
                  disabled={isAddWorking}
                  onClick={() => {
                    addSelectThisPage(addItems);
                    setAddSelectMenuOpen(false);
                  }}
                >
                  Select this page ({addItems.length})
                </button>

                <button
                  type="button"
                  className="cpAddClubsMenuItem"
                  disabled={isAddWorking}
                  onClick={() => {
                    addSelectAllMatching();
                    setAddSelectMenuOpen(false);
                  }}
                >
                  Select all matching filters ({addTotal})
                </button>

                <div className="cpAddClubsMenuDivider" />

                <button
                  type="button"
                  className="cpAddClubsMenuItem"
                  disabled={isAddWorking}
                  onClick={() => {
                    addClearSelection();
                    setAddSelectMenuOpen(false);
                  }}
                >
                  Clear selection
                </button>
              </div>
            ) : null}
          </div>

          <button
            type="button"
            className="cpDsBtn cpDsBtnPrimary cpAddClubsPrimaryBtn"
            onClick={onAddSelected}
            disabled={!canEdit || isAddWorking || !addHasAnySelection}
          >
            {isAddWorking ? 'Adding clubs...' : `Add selected clubs (${addSelectedCount})`}
          </button>

          <div className="cpMuted cpAddClubsRange">
            Showing {addFrom}-{addTo} of {addTotal}
          </div>
        </>
      }
      right={
        <ClubProgrammePager
          page={addPage}
          pages={addPages}
          from={addFrom}
          to={addTo}
          total={addTotal}
          onPageChange={loadAddPage}
          isDisabled={isAddWorking}
          minWidth={170}
        />
      }
    />
  );
};
